import { useApi } from "@lending/lib/api";

interface Props {
  onSuccess?: () => Promise<void>;
  onError?: (error: unknown) => void;
}

function useCreateVehicleLoanOfferSelectionQuery({ onSuccess, onError }: Props = {}) {
  const $api = useApi();

  return $api.useMutation("post", "/v2/lending/vehicle_loan_offer_selections/", {
    onSuccess,
    onError,
  });
}

export { useCreateVehicleLoanOfferSelectionQuery };
